import elzero from '../images/elzero web.png';
import kasper from '../images/kasper.png'
import leon from '../images/leon.png'
import specail from '../images/specail.png'
import bondi from '../images/bondi.png'
import azkar from '../images/azkar.png'
import todoList from '../images/todo-list.png'
import eBook from '../images/UdasityProject.png'
import newPortfolio from '../images/myNewPortfolio.png'
import oldPortfolio from '../images/old portfolio.png'
import speedGame from '../images/speedGame.png'
import sginInup from '../images/sgin-in-up.png'

const Data = [
    {
        "id": 1,
        "title": "elzero",
        "category": "React",
        "img": `${eBook}`,
        "link": "https://udacity-ebook.netlify.app",
        "aos": "fade-right"
    },
    {
        "id": 2,
        "title": "Landing",
        "category": "Bootstartp",
        "img": `${bondi}`,
        "link": "https://mhmh-m.github.io/Bondi/",
        "aos": "fade-up"
    },
    {
        "id": 3,
        "title": "Landing",
        "category": "Without a framework",
        "img": `${elzero}`,
        "link": "https://mhmh-m.github.io/elzero/",
        "aos": "fade-left"
    },
    {
        "id": 4,
        "title": "Landing",
        "category": "Without a framework",
        "img": `${kasper}`,
        "link": "https://mhmh-m.github.io/kasper/",
        "aos": "fade-up-right"
    },
    {
        "id": 5,
        "title": "Landing",
        "category": "Without a framework",
        "img": `${leon}`,
        "link": "https://mhmh-m.github.io/leon/",
        "aos": "fade-up"
    },
    {
        "id": 6,
        "title": "Landing",
        "category": "Without a framework",
        "img": `${specail}`,
        "link": "https://mhmh-m.github.io/special_Design/",
        "aos": "fade-up-left"
    },
    {
        "id": 7,
        "title": "Landing",
        "category": "Without a framework",
        "img": `${azkar}`,
        "link": "https://mhmh-m.github.io/azkar/",
        "aos": "fade-up-right"
    },
    {
        "id": 8,
        "title": "todo-list",
        "category": "Without a framework",
        "img": `${todoList}`,
        "link": "https://mhmh-m.github.io/To-Do-Application/",
        "aos": "fade-up"
    },
    {
        "id": 9,
        "title": "oldPortfolio",
        "category": "Without a framework",
        "img": `${oldPortfolio}`,
        "link": "https://mhmh-m.github.io/Portfolio/",
        "aos": "fade-up-left"
    },
    {
        "id": 10,
        "title": "newPortfolio",
        "category": "React",
        "img": `${newPortfolio}`,
        "link": "#",
        "aos": "fade-right"
    },
    {
        "id": 11,
        "title": "speedGame",
        "category": "Without a framework",
        "img": `${speedGame}`,
        "link": "https://mhmh-m.github.io/Typing-Speed-Game/",
        "aos": "fade-up"
    },
    {
        "id": 12,
        "title": "sginInup",
        "category": "Without a framework",
        "img": `${sginInup}`,
        "link": "https://mhmh-m.github.io/sgin-in-up/",
        "aos": "fade-left"
    },
];

export default Data;